var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"rounded-xl d-flex justify-space-between google-btn",attrs:{"tile":"","outlined":""},on:{"click":_vm.googleLogin}},[_c('span',{staticClass:"pl-3"},[_vm._v(" התחבר באמצעות GOOGLE ")]),_c('MyIconImage',{attrs:{"type":"svg","name":"Google Logo","maxWidth":"140"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }